import { uniq } from 'lodash-es';
import { TrialProgramImage } from '@ui';
import { OrganType } from '@/api/apis/case/index';

interface TrialProgramLogosProps {
  trialPrograms?: { organ: OrganType }[];
  width?: number;
  height?: number;
}

export const TrialProgramLogos = ({ trialPrograms, width, height }: TrialProgramLogosProps) => {
  const organs = uniq(trialPrograms?.map((p) => p.organ));

  if (!organs.length) return null;
  return (
    <div className="flex gap-2 items-center">
      {organs.map((organ) => (
        <TrialProgramImage key={organ} organ={organ} width={width} height={height} />
      ))}
    </div>
  );
};
